import React, { Suspense, lazy } from 'react';
import { Routes, Route } from 'react-router-dom';
import IsraelSchedulePage from './pages/IsraelSchedulePage';
import IsraelLandingPage from './pages/IsraelLandingPage';
import VideoLoading from './components/video/VideoLoading';

// Lazy: keeps the LiveKit client out of the bundle a patient loads to book a slot.
const VideoJoinPage = lazy(() => import('./pages/VideoJoinPage'));

// Israel-clinic patient-facing app: only public (no-auth) flows. Rendered on
// the Israel patient domain (see config/appMode.ts). Hebrew / RTL. Does NOT
// reuse the UK SchedulingFlow — it has its own look and behaviour.
function IsraelApp() {
  return (
    <Routes>
      <Route path="/schedule/:token" element={<IsraelSchedulePage />} />
      {/* IL video links land here, on this domain rather than the UK patient
          app - same page as the UK patients use, rendered in Hebrew/RTL from
          the locale the video service returns for a clinicui meeting. */}
      <Route
        path="/join/:joinUuid"
        element={<Suspense fallback={<VideoLoading />}><VideoJoinPage defaultLang="he" /></Suspense>}
      />
      {/* Unknown/root URL → neutral landing, never the therapist login */}
      <Route path="*" element={<IsraelLandingPage />} />
    </Routes>
  );
}

export default IsraelApp;
